<template>
  <dl :class="$style.techReferencesList">
    <dt>{{ t('techReferences.adNumber') }}</dt>
    <dd>{{ adNumber }}</dd>

    <template v-if="objectReferenceID">
      <dt>{{ t('techReferences.objectReference') }}</dt>
      <dd>{{ objectReferenceID }}</dd>
    </template>
  </dl>
</template>

<script lang="ts" setup>
import { Listing } from '@smg-real-estate/hg-rets-schema';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

defineOptions({
  name: 'ListingTechReferences',
});

interface Props {
  listing: Listing;
}
const props = defineProps<Props>();

const adNumber = computed(() => props.listing.id);
const objectReferenceID = computed(() => props.listing.externalIds?.displayPropertyReferenceId);
</script>

<style lang="scss" module>
.techReferencesList {
  dd {
    word-wrap: break-word;
  }
}
</style>
